export abstract class BillingRoutesConstants {
  static readonly MAIN = "billing";
  static readonly SUCCESS = "success";
  static readonly CANCEL = "cancel";

  static readonly main = (): string => `/${this.MAIN}`;
  static readonly success = (): string => `${this.main()}/${this.SUCCESS}`;
  static readonly cancel = (): string => `${this.main()}/${this.CANCEL}`;
}
